import { inferenceHttp } from '@/lib/api/http-client';
import { type ContextDto, AgentRunnerService } from '@inference.engine/api-client/web';

/**
 * Mints a fresh runtime context for the given agent. Domain-agnostic — used
 * by any feature that initiates an agent session (chat, brief generation,
 * future agentic flows).
 *
 * Lifted from `features/chats/api/chats.api.ts` (re-exported from old path
 * for backward compat) so non-chat consumers don't cross feature boundaries.
 *
 * Function name kept for backward compat with all existing callers; consider
 * renaming to `createAgentRunnerContext` in a future cleanup.
 */
export const createChatId = async (
  agentId: string,
  title?: string,
  isHidden?: boolean,
): Promise<ContextDto> => {
  try {
    const response = await AgentRunnerService.initRunnerContext({
      client: inferenceHttp,
      body: { agentId, title, isHidden },
    });

    if (!response.data) {
      throw new Error('No data returned from initRunnerContext');
    }

    return response.data;
  } catch (error) {
    throw new Error(
      `Failed to initialize chat: ${error instanceof Error ? error.message : 'Unknown error'}`,
      { cause: error },
    );
  }
};
